import useProfile from "@/hooks/useProfile";
import { Profile } from "@/schema/Profile";
import { getCookie } from "cookies-next";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

function Layout() {
  const { setProfile } = useProfile();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const userData = getCookie("user") as string;
      const user = JSON.parse(userData) as Profile;
      setProfile(user);
    } catch (error) {
      navigate("/app/login");
    }
  }, []);

  return (
    <div className="h-full">
      <Outlet />
    </div>
  );
}

export default Layout;